import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { CheckCircle2, Loader2, XCircle, Clock } from 'lucide-react';
import { useApp } from '../context/AppContext';
import api from '../api';

export default function PaymentSuccess() {
  const nav = useNavigate();
  const [params] = useSearchParams();
  const sid = params.get('session_id');
  const { refreshUser } = useApp();
  const [status, setStatus] = useState('checking');

  useEffect(() => {
    let tries = 0; let t;
    const poll = async () => {
      try {
        const r = await api.get(`/payments/status/${sid}`);
        if (r.data.payment_status === 'paid') { setStatus('paid'); await refreshUser(); return; }
        if (['failed', 'expired'].includes(r.data.payment_status)) { setStatus('failed'); return; }
      } catch (e) {}
      if (++tries >= 15) { setStatus('timeout'); return; }
      t = setTimeout(poll, 2000);
    };
    if (sid) poll(); else setStatus('failed');
    return () => clearTimeout(t);
  }, [sid]);

  return (
    <div className="flex min-h-screen items-center justify-center bg-background px-6">
      <div className="w-full max-w-md rounded-3xl bg-white p-8 text-center card-soft animate-pop">
        {status === 'checking' && (
          <>
            <Loader2 className="mx-auto h-12 w-12 animate-spin text-[hsl(var(--coral))]" />
            <h1 className="mt-4 text-2xl font-extrabold">Confirming your payment…</h1>
            <p className="mt-1 text-muted-foreground">Hang tight, this only takes a moment.</p>
          </>
        )}
        {status === 'paid' && (
          <>
            <div className="mx-auto flex h-16 w-16 items-center justify-center rounded-full bg-accent"><CheckCircle2 className="h-9 w-9 text-[hsl(var(--coral))]" /></div>
            <h1 className="mt-4 text-2xl font-extrabold">You’re all set!</h1>
            <p className="mt-1 text-muted-foreground">Payment successful. Your subscription is now active.</p>
            <button onClick={() => nav('/app/profile')} className="coral-btn mt-6 w-full rounded-2xl py-3.5 font-bold text-white">Back to Purrflect</button>
          </>
        )}
        {(status === 'failed' || status === 'timeout') && (
          <>
            <div className="mx-auto flex h-16 w-16 items-center justify-center rounded-full bg-secondary">
              {status === 'timeout' ? <Clock className="h-9 w-9 text-muted-foreground" /> : <XCircle className="h-9 w-9 text-destructive" />}
            </div>
            <h1 className="mt-4 text-2xl font-extrabold">{status === 'timeout' ? 'Still processing' : 'Payment not completed'}</h1>
            <p className="mt-1 text-muted-foreground">{status === 'timeout' ? 'Your payment is taking a little longer. It may complete shortly.' : 'No charge was made. You can try again anytime.'}</p>
            <button onClick={() => nav('/app/profile')} className="mt-6 w-full rounded-2xl border border-border bg-white py-3.5 font-bold">Back to app</button>
          </>
        )}
      </div>
    </div>
  );
}
